var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { components } from "react-select";
import DeprecatedSelect from "../DeprecatedSelect/DeprecatedSelect";
import { debouncePromise } from "../../../../util/debounce";
import ReactSelectWithLookupModal, { ReactSelectLookupButton, } from "../ReactSelectWithLookupModal/ReactSelectWithLookupModal";
import useConfirmation from "../../Hooks/useConfirmation";
function _makeSearch(config, multi) {
    function Search(_a) {
        var { id, name, "aria-label": ariaLabel, formErrors, hasError: _hasError, errorMessage, disabled, lookupModal, onChange, value, style, placeholder, additionalOptions, className, defaultOptions, cacheOptions, noOptionsMessage, onFocus, onBlur, minNumSearchCharacters, detailButton, maxShown, detailButtonProps, selectionConfirmation } = _a, otherProps = __rest(_a, ["id", "name", "aria-label", "formErrors", "hasError", "errorMessage", "disabled", "lookupModal", "onChange", "value", "style", "placeholder", "additionalOptions", "className", "defaultOptions", "cacheOptions", "noOptionsMessage", "onFocus", "onBlur", "minNumSearchCharacters", "detailButton", "maxShown", "detailButtonProps", "selectionConfirmation"]);
        const [isLookupModalOpen, setIsLookupModalOpen] = React.useState(false);
        const shownResponseNumber = maxShown || 50;
        const renderValue = (option) => {
            if (!Array.isArray(value)) {
                return null;
            }
            if (value.indexOf(option) <= shownResponseNumber - 1) {
                return typeof config.label === "string"
                    ? option[config.label]
                    : config.label;
            }
            if (value.indexOf(option) === shownResponseNumber) {
                return _jsxs("span", { children: ["...", value.length - shownResponseNumber, " more items"] });
            }
            return null;
        };
        // @ts-expect-error react types issue
        const MultiValueContainer = (props) => {
            if (!Array.isArray(value)) {
                return null;
            }
            const option = props.data;
            if (value.indexOf(option) > shownResponseNumber) {
                return null;
            }
            if (value.indexOf(option) <= shownResponseNumber - 1) {
                return _jsx(components.MultiValueContainer, Object.assign({}, props));
            }
            if (value.indexOf(option) === shownResponseNumber) {
                return React.Children.toArray(props.children)[0];
            }
            return null;
        };
        const hasError = _hasError == null
            ? // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
                Object.keys(formErrors || {}).includes(name)
            : _hasError;
        const [confirmation, confirmationModals] = useConfirmation();
        const typeAhead = (makeStyles) => (_jsxs(_Fragment, { children: [confirmationModals, _jsx(DeprecatedSelect.Async, { id: id, multi: multi, "aria-label": ariaLabel, name: name, defaultOptions: defaultOptions, cacheOptions: cacheOptions, noOptionsMessage: noOptionsMessage, onFocus: onFocus, onBlur: onBlur, disabled: disabled, placeholder: placeholder, style: makeStyles(style || {}), className: classNames({ "is-invalid": hasError }, className || ""), getOptionLabel: typeof config.label === "string"
                        ? (option) => option[config.label]
                        : config.label, getOptionValue: typeof config.value === "string"
                        ? (option) => option[config.value]
                        : config.value, optionRenderer: config.formatOption, loadOptions: debouncePromise((search) => __awaiter(this, void 0, void 0, function* () {
                        if (minNumSearchCharacters != null &&
                            (search === null || search === void 0 ? void 0 : search.length) < minNumSearchCharacters) {
                            return additionalOptions || [];
                        }
                        const options = (yield config.loadOptions(search, otherProps));
                        const ops = {
                            options: (additionalOptions !== null && additionalOptions !== void 0 ? additionalOptions : []).concat(options),
                        };
                        return ops;
                    }), 100), onChange: (selected) => __awaiter(this, void 0, void 0, function* () {
                        var _b;
                        const confirmationConfig = selectionConfirmation === null || selectionConfirmation === void 0 ? void 0 : selectionConfirmation(selected);
                        if (confirmationConfig) {
                            const confirmed = yield confirmation(confirmationConfig.message);
                            if (confirmed) {
                                (_b = confirmationConfig.onConfirmed) === null || _b === void 0 ? void 0 : _b.call(confirmationConfig);
                            }
                            else {
                                // If this isn't confirmed, we don't want to call onChange
                                // or do anything
                                return;
                            }
                        }
                        onChange === null || onChange === void 0 ? void 0 : onChange(selected);
                    }), 
                    // @ts-expect-error for some reason this works.  I think it's because react-select can accept a function as a value renderer. Ignore for now
                    valueRenderer: maxShown == null ? undefined : renderValue, components: maxShown == null ? undefined : { MultiValueContainer }, value: value })] }));
        const getDefault = () => (_jsxs(_Fragment, { children: [typeAhead((styles) => styles), _jsx("div", { className: "invalid-feedback", children: errorMessage })] }));
        if (multi) {
            const LookupModal = config.lookupModal;
            if (LookupModal && lookupModal) {
                return (_jsxs(_Fragment, { children: [_jsx(ReactSelectWithLookupModal, { lookupButton: _jsx(ReactSelectLookupButton, { onClick: () => setIsLookupModalOpen(true) }), select: typeAhead }), _jsx(LookupModal, Object.assign({ isOpen: isLookupModalOpen, 
                            // @ts-expect-error - TS7006 - Parameter 'items' implicitly has an 'any' type.
                            onApply: (items) => onChange && onChange(items), selected: value, onModalClosed: () => setIsLookupModalOpen(false) }, (typeof lookupModal === "boolean" ? null : lookupModal))), _jsx("div", { className: "invalid-feedback", children: errorMessage })] }));
            }
            return getDefault();
        }
        // not multi -- use the detail if it was provided
        let DetailB;
        if (typeof detailButton === "boolean") {
            DetailB =
                detailButton && config.detailButton ? config.detailButton : null;
        }
        else {
            DetailB = detailButton !== null && detailButton !== void 0 ? detailButton : config.detailButton;
        }
        if (DetailB) {
            return (_jsx(ReactSelectWithLookupModal
            // @ts-expect-error this is a pretty complicated error and it's not important to deal with now
            , { 
                // @ts-expect-error this is a pretty complicated error and it's not important to deal with now
                lookupButton: _jsx(DetailB, Object.assign({}, detailButtonProps, { val: value })), select: typeAhead }));
        }
        return getDefault();
    }
    return Search;
}
export function makeSearch(config) {
    return _makeSearch(config, false);
}
export function makeMultiSearch(config) {
    // @ts-expect-error not sure what the error is here, not willing to fix it now.
    return _makeSearch(config, true);
}
